
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocumentSectionTypeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentSectionType"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentSectionInputText"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentSectionInputTextFragment"},"directives":[]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentSectionInputNumber"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentSectionInputNumberFragment"},"directives":[]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentSectionSelectField"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentSectionSelectFieldFragment"},"directives":[]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentSectionRadioGroup"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentSectionRadioGroupFragment"},"directives":[]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentSectionSignature"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentSectionSignatureFragment"},"directives":[]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentSectionImage"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentSectionImageFragment"},"directives":[]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentSectionLogo"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentSectionLogoFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":984}};
    doc.loc.source = {"body":"#import \"./DocumentSectionInputTextFragment.graphql\"\n#import \"./DocumentSectionInputNumberFragment.graphql\"\n#import \"./DocumentSectionSelectFieldFragment.graphql\"\n#import \"./DocumentSectionRadioGroupFragment.graphql\"\n#import \"./DocumentSectionSignatureFragment.graphql\"\n#import \"./DocumentSectionImageFragment.graphql\"\n#import \"./DocumentSectionLogoFragment.graphql\"\n\nfragment DocumentSectionTypeFragment on DocumentSectionType {\n  ... on DocumentSectionInputText {\n    ...DocumentSectionInputTextFragment\n  }\n  ... on DocumentSectionInputNumber {\n    ...DocumentSectionInputNumberFragment\n  }\n  ... on DocumentSectionSelectField {\n    ...DocumentSectionSelectFieldFragment\n  }\n  ... on DocumentSectionRadioGroup {\n    ...DocumentSectionRadioGroupFragment\n  }\n  ... on DocumentSectionSignature {\n    ...DocumentSectionSignatureFragment\n  }\n  ... on DocumentSectionImage {\n    ...DocumentSectionImageFragment\n  }\n  ... on DocumentSectionLogo {\n    ...DocumentSectionLogoFragment\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("./DocumentSectionInputTextFragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./DocumentSectionInputNumberFragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./DocumentSectionSelectFieldFragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./DocumentSectionRadioGroupFragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./DocumentSectionSignatureFragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./DocumentSectionImageFragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./DocumentSectionLogoFragment.graphql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["DocumentSectionTypeFragment"] = oneQuery(doc, "DocumentSectionTypeFragment");
        
